/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanySearchResult,
  JobSearchCategories,
  JobSearchFilter,
  JobSearchResult,
  JobSearchSavedSearch,
} from '../models/index';
import {
    CompanySearchResultFromJSON,
    CompanySearchResultToJSON,
    JobSearchCategoriesFromJSON,
    JobSearchCategoriesToJSON,
    JobSearchFilterFromJSON,
    JobSearchFilterToJSON,
    JobSearchResultFromJSON,
    JobSearchResultToJSON,
    JobSearchSavedSearchFromJSON,
    JobSearchSavedSearchToJSON,
} from '../models/index';

export interface DeleteSearchRequest {
    body?: number;
}

export interface FilterJobsRequest {
    jobSearchFilter?: JobSearchFilter;
}

export interface GetCompaniesRequest {
    companyName?: string;
}

export interface GetJobFiltersRequest {
    language?: string;
}

export interface GetLastSearchRequest {
    page?: number;
}

export interface SaveSearchRequest {
    jobSearchFilter?: JobSearchFilter;
}

/**
 * 
 */
export class JobSearchApiV2Api extends runtime.BaseAPI {

    /**
     */
    async deleteSearchRaw(requestParameters: DeleteSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobSearchApiV2/DeleteSearch`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteSearch(requestParameters: DeleteSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.deleteSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async filterJobsRaw(requestParameters: FilterJobsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobSearchResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobSearchApiV2/FilterJobs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobSearchFilterToJSON(requestParameters.jobSearchFilter),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async filterJobs(requestParameters: FilterJobsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobSearchResult> {
        const response = await this.filterJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCompaniesRaw(requestParameters: GetCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanySearchResult>> {
        const queryParameters: any = {};

        if (requestParameters.companyName !== undefined) {
            queryParameters['companyName'] = requestParameters.companyName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobSearchApiV2/GetCompanies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanySearchResultFromJSON(jsonValue));
    }

    /**
     */
    async getCompanies(requestParameters: GetCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanySearchResult> {
        const response = await this.getCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getJobFiltersRaw(requestParameters: GetJobFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobSearchCategories>> {
        const queryParameters: any = {};

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobSearchApiV2/GetJobFilters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobSearchCategoriesFromJSON(jsonValue));
    }

    /**
     */
    async getJobFilters(requestParameters: GetJobFiltersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobSearchCategories> {
        const response = await this.getJobFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLastSearchRaw(requestParameters: GetLastSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobSearchResult>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobSearchApiV2/GetLastSearch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async getLastSearch(requestParameters: GetLastSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobSearchResult> {
        const response = await this.getLastSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSavedSearchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<JobSearchSavedSearch>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobSearchApiV2/GetSavedSearches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(JobSearchSavedSearchFromJSON));
    }

    /**
     */
    async getSavedSearches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<JobSearchSavedSearch>> {
        const response = await this.getSavedSearchesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async saveSearchRaw(requestParameters: SaveSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobSearchApiV2/SaveSearch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobSearchFilterToJSON(requestParameters.jobSearchFilter),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async saveSearch(requestParameters: SaveSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.saveSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
